/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const SET_PLAN_TYPE = 'SET_PLAN_TYPE';
export const SET_REBATE_PROGRAM = 'SET_REBATE_PROGRAM';
export const SET_REBATE_LIST = 'SET_REBATE_LIST';
export const SET_TASK_TYPE = 'SET_TASK_TYPE';
export const SET_REMINDER_SETUP_LIST = 'SET_REMINDER_SETUP_LIST';
export const GET_ALL_TEMPLATE_TYPE = 'GET_ALL_TEMPLATE_TYPE';
export const INPUT_FIELD_VALUE_ACTION = 'INPUT_FIELD_VALUE_ACTION';
export const GET_CHECKLOG_ERROR_MSG = 'GET_CHECKLOG_ERROR_MSG';
export const GET_CHECKSUSP_ERROR_MSG = 'GET_CHECKSUSP_ERROR_MSG';
export const GET_COLLECT_ERROR_MSG = 'GET_COLLECT_ERROR_MSG';
export const GET_MAILED_DATE_ERROR_MSG = 'GET_MAILED_DATE_ERROR_MSG';
export const SAVE_OR_UPDATE_RR = 'SAVE_OR_UPDATE_RR';
export const DELETE_REMINDER = 'DELETE_REMINDER';
